import { c as _c } from "react/compiler-runtime";
import { Button, IconButton, Stack } from '@mui/material';
export const VXButtons = t0 => {
  const $ = _c(14);
  const {
    onApprove,
    onCancel,
    approveDisabled
  } = t0;
  let t1;
  if ($[0] !== onApprove) {
    t1 = () => {
      onApprove();
    };
    $[0] = onApprove;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <i className="material-symbols-check w-[20px] h-[20px]" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== approveDisabled || $[4] !== t1) {
    t3 = <Button data-testid="v-btn" disabled={approveDisabled} onClick={t1} variant="contained" className="min-w-[20px]! p-[6px]">{t2}</Button>;
    $[3] = approveDisabled;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onCancel) {
    t4 = () => {
      onCancel();
    };
    $[6] = onCancel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <i className="material-symbols-close-rounded w-[20px] h-[20px] text-(--mui-palette-text-primary)" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <IconButton data-testid="x-btn" onClick={t4}>{t5}</IconButton>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <Stack direction="row" alignItems="center" gap="8px">{t3}{t6}</Stack>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};